<template>
    <v-container>
        <v-row>
            <v-col>
                <span class="headline">Oversikt søknader</span>
                <v-select v-model="currentYear" :items="years" label="Velg årstall"></v-select>
                <v-data-table :items="applications" :headers="headers" hide-default-footer disable-pagination :mobile-breakpoint="0">
                    <template v-slot:item={item}>
                        <tr style="cursor: pointer;">
                            <td @click="applicationClicked(item)">
                                {{item.name}}
                            </td>
                            <td @click="applicationClicked(item)">
                                {{
                                    (() => {
                                        let selectedArea = item.applicationChoices.find(ac => ac.selected && ac.type == 10);
                                        return selectedArea? selectedArea.name : 'Mangler';
                                        })()
                                }}
                            </td>

                            <td @click="applicationClicked(item)">{{item.createdBy ? formatDate(item.createdAt) : '-'}}</td>
                            <td @click="applicationClicked(item)">{{createdBy(item)}}</td>

                            <td @click="applicationClicked(item)">{{item.updatedAt ? formatDate(item.updatedAt) : '-'}}</td>
                            <td @click="applicationClicked(item)">{{updatedBy(item)}}</td>

                            <td @click="applicationClicked(item)">
                                <!-- <v-badge bordered overlap :icon="statusIcon(item.status)"> -->
                                <v-chip :color="item.step < 6 ? 'error lighten-3': 'success lighten-1'">{{progress(item)}}%</v-chip>
                                <!-- </v-badge> -->
                            </td>
                            <td @click="applicationClicked(item)">
                                <v-icon>{{applicationStatusIcon(getLastStatus(item).type)}}</v-icon>
                                {{applicationStatusText(getLastStatus(item).type)}}
                            </td>
                            <td>
                                <div class="d-flex justify-center">
                                    <v-icon v-if="!downloadingPdf || (downloadingPdf && downloadingAppId != item.id)" @click="downloadPdf(item)" :disabled="$vuetify.breakpoint.mobile">mdi-file-pdf-box</v-icon>
                                    <v-progress-circular v-if="downloadingPdf && downloadingAppId == item.id" size="16" width="2" indeterminate color="colors.background"></v-progress-circular>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:no-data>
                        <div>Ingen søknader</div>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog v-model="showAdmitted" max-width="500">
            <v-card>
                <v-card-title class="headline white--text" :style="{background: appColors.primary1}">
                    <span>Søknad levert</span>
                </v-card-title>
                <v-card-text class="mt-2">
                    <span>Søknad er levert og dere vil få et svart i kort tid.</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="showAdmitted=false" text color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>

        <v-dialog v-model="showInprogress" max-width="500">
            <v-card>
                <v-card-title class="headline white--text" :style="{background: appColors.primary1}">
                    <span>Søknad under behandling</span>
                </v-card-title>
                <v-card-text class="mt-2">
                    <span>Søknaden er under behandling. Vennligst vent på svar.</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="showInprogress=false" text color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showStale" max-width="500">
            <v-card>
                <v-card-title class="headline white--text" :style="{background: appColors.primary1}">
                    <span>Søknad foreldet</span>
                </v-card-title>
                <v-card-text class="mt-2">
                    <span>Søknaden har gått ut. Ta kontakt med oss eller søke på nytt.</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="showStale = false" text color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showRejected" max-width="500">
            <v-card>
                <v-card-title class="headline white--text" :style="{background: appColors.primary1}">
                    <span>Søknad avslått</span>
                </v-card-title>
                <v-card-text class="mt-2">
                    <span>Søknaden er dessverre avslått.</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="showRejected = false" text color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showDone" max-width="500">
            <v-card>
                <v-card-title class="headline white--text" :style="{background: appColors.primary1}">
                    <span>Søknad ferdig</span>
                </v-card-title>
                <v-card-text class="mt-2">
                    <span>Søknaden er ferdig.</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="showDone = false" text color="primary">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import * as axios from "axios";
import * as moment from "moment";
import { ApplicationStatus } from "../utilities/enums";
import { colors as appColors } from "../utilities/colors";
import { mapState } from "vuex";
export default {
    data() {
        return {
            appColors,
            currentYear: 0,
            years: [],
            applications: [],
            headers: [
                { text: "Navn", value: "name" },
                { text: "Formålsområde" },
                {
                    text: "Opprettet",
                    value: "createdAt",
                    filter: createdAt => {
                        return Number(moment.unix(createdAt).year()) === Number(this.currentYear);
                    }
                },
                { text: "Opprettet av", value: "createdBy" },
                { text: "Sist oppdatert", value: "updatedAt" },
                { text: "Oppdatert av", value: "updatedBy" },
                { text: "Framgang", value: "step" },
                { text: "Status" },
                { text: "Last ned", sortable: false}
            ],
            showAdmitted: false,
            showInprogress: false,
            showStale: false,
            showRejected: false,
            showDone: false,
            downloadingPdf: false,
            downloadingAppId: undefined
        };
    },
    computed: {
        ...mapState({
            company: function(state) {
                return state.company;
            }
        })
    },
    watch: {
        company: async function() {
            this.applications = await this.$store.dispatch("getApplicationsByCompany", {});
            this.$store.commit("snackbar", {
                text: `${this.applications.length} ${this.applications.length == 0 || this.applications.length > 1 ? "søknader" : "søknad"} hentet`,
                color: "success"
            });
        }
    },
    methods: {
        formatDate(unix) {
            return moment.unix(unix).format("[kl.] HH:mm på DD.MM.YYYY");
        },
        applicationClicked(application) {
            // if (this.$store.getters.user.role === Role.SUPERUSER) {
            //     this.$router.push({
            //         name: "application",
            //         params: { id: application.id }
            //     });
            //     return;
            // }

            switch (this.getLastStatus(application).type) {
                case ApplicationStatus.CREATED:
                case ApplicationStatus.NEEDINFO: {
                    this.$router.push({
                        name: "application",
                        params: { id: application.id }
                    });
                    break;
                }
                case ApplicationStatus.STALE: {
                    this.showStale = true;
                    break;
                }
                case ApplicationStatus.ADMITTED: {
                    this.showAdmitted = true;
                    break;
                }
                case ApplicationStatus.INPROGRESS: {
                    this.showInprogress = true;
                    break;
                }
                case ApplicationStatus.REJECTED: {
                    this.showRejected = true;
                    break;
                }
                case ApplicationStatus.GRANTED: {
                    this.$router.push({
                        name: "reporting",
                        params: { id: application.id }
                    });
                    break;
                }
                case ApplicationStatus.DONE: {
                    this.showDone = true;
                    break;
                }
                default: {
                    break;
                }
            }
        },
        createdBy(application) {
            if (!application.createdBy) {
                return "-";
            }

            if (application.createdBy.firstname && application.createdBy.lastname) {
                return `${application.createdBy.firstname} ${application.createdBy.lastname}`;
            } else if (application.createdBy.email) {
                return application.createdBy.email;
            } else {
                return "-";
            }
        },
        updatedBy(application) {
            if (!application.updatedBy) {
                return "-";
            }

            if (application.updatedBy.firstname && application.updatedBy.lastname) {
                return `${application.updatedBy.firstname} ${application.updatedBy.lastname}`;
            } else if (application.updatedBy.email) {
                return application.updatedBy.email;
            } else {
                return "-";
            }
        },
        getLastStatus(application) {
            if (!application.statuses || application.statuses.length == 0) {
                return { type: ApplicationStatus.UNKNOWN };
            }

            return application.statuses[application.statuses.length - 1];
        },
        progress(application) {
            if(application){
                switch(application.step){
                    case 1: {
                        return 10;
                    }
                    case 2: {
                        return 20;
                    }
                    case 3: {
                        return 30;
                    }
                    case 4: {
                        return 60;
                    }
                    case 5: {
                        return 85;
                    }
                    case 6: {
                        // getLastStatus(item).type
                        if(this.getLastStatus(application).type === ApplicationStatus.ADMITTED){
                            return 100;
                        }

                        return 90;
                    }
                }
            }
            else{
                return 0;
            }
        },
        async downloadPdf(app) {
            try {
                    this.downloadingPdf = true;
                    this.downloadingAppId = app.id;

                    let filedata = (await axios.post(`/exportPdf/generate`, { applicationId: app.id})).data;
                    let blob = new Blob([Buffer.from(filedata,"base64")], {type:"application/pdf"});
                    var link = document.createElement("a");

                    link.href = window.URL.createObjectURL(blob);
                    link.download = `${app.name}_${moment().format("YYYYMMDDHHmm")}.pdf`;

                    document.body.appendChild(link);

                    link.click();

                    document.body.removeChild(link);
                    
                    this.downloadingPdf = false;
                    this.downloadingAppId = undefined;
                } catch (error) {
                    // TODO
                    this.downloadingPdf = false;
                    this.downloadingAppId = undefined;
                }
        }
    },
    async mounted() {
        let startYear = 2000;
        let endYear = moment().year();

        for (let year = startYear; year <= endYear; year++) {
            this.years.unshift(year);
        }

        this.currentYear = endYear;

        try {
            if(this.$store.getters.company){
                this.applications = await this.$store.dispatch("getApplicationsByCompany", {});
            }
            
            this.$store.commit("snackbar", {
                text: `${this.applications.length} ${this.applications.length == 0 || this.applications.length > 1 ? "søknader" : "søknad"} hentet`,
                color: "success"
            });
        } catch {
            this.$store.commit("snackbar", {
                text: "Henting av søknader feilet.",
                color: "error"
            });
            // console.log(err);
        }
    }
};
</script>

<style lang="scss" scoped>
</style>